import { render, staticRenderFns } from "./TabelHeaderForEdit.vue?vue&type=template&id=45ea1934&"
import script from "./TabelHeaderForEdit.vue?vue&type=script&lang=js&"
export * from "./TabelHeaderForEdit.vue?vue&type=script&lang=js&"
import style0 from "./TabelHeaderForEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45ea1934')) {
      api.createRecord('45ea1934', component.options)
    } else {
      api.reload('45ea1934', component.options)
    }
    module.hot.accept("./TabelHeaderForEdit.vue?vue&type=template&id=45ea1934&", function () {
      api.rerender('45ea1934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DeliveryNote/MaintainDeliveryNote2/components/TabelHeaderForEdit.vue"
export default component.exports